import { Controller } from "@hotwired/stimulus"

// Показывает/скрывает блок полей горизонтальной ориентации на форме
// пресета размеров по чекбоксу landscape_enabled.
export default class extends Controller {
  static targets = ["landscapeCheckbox", "landscapeFields"]

  connect() {
    this.syncLandscape()
  }

  syncLandscape() {
    // Блок горизонтальной ориентации может быть скрыт из формы целиком.
    if (!this.hasLandscapeCheckboxTarget || !this.hasLandscapeFieldsTarget) return
    this.landscapeFieldsTarget.hidden = !this.landscapeCheckboxTarget.checked
  }
}
